import { Select } from "antd";
import React from "react";
import styles from "../styles.module.scss";

export default function CustomSelect({
  title,
  required = false,
  placeholder = "-",
  value,
  onChange,
  options = [],
  disabled = false,
  allowClear = true,
  showSearch = false,
  style,
  mode, // 👈 multiple | tags | undefined
  maxTagCount = "responsive",
  optionFilterProp = "label",
}) {
  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}

      <Select
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        options={options}
        allowClear={allowClear}
        showSearch={showSearch}
        optionFilterProp={optionFilterProp}
        mode={mode} // 👈 энд л боллоо
        maxTagCount={maxTagCount}
        size="large"
        style={{
          minHeight: 40,
          ...style,
          // width: "100%"
        }}
      />
    </div>
  );
}
